/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LoadingBarExpanded/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function LoadingBarExpanded({
  children,
  viewPath = "/DesignSystem/LoadingBarExpanded"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="LoadingBarExpanded.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={10}
 borderBottomRightRadius={10}
 borderTopLeftRadius={10}
 borderTopRightRadius={10}
 height={16}
 width={320}
/>
</div>
{children}
</React.Fragment>)
}